import { render, staticRenderFns } from "./NotificacionFormImplicado.vue?vue&type=template&id=1af5839d"
import script from "./NotificacionFormImplicado.vue?vue&type=script&lang=js"
export * from "./NotificacionFormImplicado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports